import React from 'react';
import DataList from '../DataList';
import { getDepartments, deleteDepartment, bulkDeleteDepartments, bulkUploadDepartments } from '../../api/data';

const DepartmentsList: React.FC = () => {
  const config = {
    title: 'Departments',
    singularName: 'department',
    columns: [
      { key: 'id', label: 'ID' },
      { key: 'name_ar', label: 'Arabic Name' },
      { key: 'name_en', label: 'English Name' },
      { key: 'head_name', label: 'Department Head' },
      { key: 'contact_email', label: 'Email' },
      { key: 'contact_phone', label: 'Phone' }
    ],
    fetchData: getDepartments,
    deleteItem: deleteDepartment,
    bulkDelete: bulkDeleteDepartments,
    bulkUpload: bulkUploadDepartments,
    createRoute: '/data/departments/create',
    editRoute: (id: number) => `/data/departments/${id}/edit`
  };

  return <DataList config={config} />;
};

export default DepartmentsList;
